var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSarigatoFoundationLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 61.192,
    viewBox: "0 0 300 61.192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sarfound-gradient",
    x1: 0.538,
    y1: 0.458,
    x2: 0.313,
    y2: 0.709,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#da0534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#dc1f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd2959"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-sarfound"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M1.99,10.709,9.158,9.065l2.15-7.675Z",
    transform: "translate(-1.99 -1.39)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 7 7"
  }, /*#__PURE__*/React.createElement("image", {
    width: 7,
    height: 7,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAACXBIWXMAAA6cAAAOnAEHlFPdAAAAcUlEQVQIW2P89+/ffwY08P/XT4ZbaQUMLOgSDH/+MFzILGL4c+gOAxOKxL9/DJdySxieH77BwMjAgCaJBhCS//4zXCmqYHi89zID5z9GVMnrlbUMj7adZeD4x8jAA5VkYWBgYHgxYzrD19UnGcTQbAEAmXQnLkJo/90AAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sarfound-gradient-2",
    x1: 0.462,
    y1: 0.458,
    x2: 0.685,
    y2: 0.709,
    xlinkHref: "#sarfound-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sarfound-gradient-3",
    x1: 0.002,
    y1: 0.499,
    x2: 1.002,
    y2: 0.499,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ca083c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#ca083c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b50c35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sarfound-gradient-4",
    x1: 0.463,
    y1: 0.457,
    x2: 0.743,
    y2: 0.781,
    xlinkHref: "#sarfound-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sarfound-gradient-5",
    x1: 0.5,
    y1: 1.114,
    x2: 0.5,
    y2: -0.066,
    xlinkHref: "#sarfound-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sarfound-gradient-6",
    x1: 1.148,
    y1: 0.5,
    x2: -0.124,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff6b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e77e00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sarfound-gradient-7",
    x1: 1.367,
    y1: 0.499,
    x2: 0.02,
    y2: 0.499,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff6b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#fbe08f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#f0ab43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ea8b12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e77e00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sarfound-gradient-8",
    x1: -0.453,
    y1: 0.215,
    x2: 1.203,
    y2: 0.611,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff6b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#f4be5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e77e00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sarfound-gradient-9",
    x1: -0.786,
    y1: 0.499,
    x2: 1.523,
    y2: 0.499,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e77e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#efa438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#f7d079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#fdeca1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff6b0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sarfound-gradient-10",
    x1: -0.104,
    y1: -0.391,
    x2: 0.73,
    y2: 0.956,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff6b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fdeca1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#f7d079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#efa438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e77e00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sarfound-gradient-11",
    x1: 0.5,
    y1: -0.198,
    x2: 0.5,
    y2: 1.049,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff6b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f2b653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e77e00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sarfound-gradient-12",
    x1: 1.114,
    y1: 0.5,
    x2: -0.032,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff6b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#f2b753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#ea8e17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e77e00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sarfound-gradient-13",
    x1: 0.5,
    y1: 1.146,
    x2: 0.5,
    y2: -0.097,
    xlinkHref: "#sarfound-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sarfound-gradient-14",
    x1: 0.507,
    y1: 0.493,
    x2: 0.135,
    y2: 0.903,
    xlinkHref: "#sarfound-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1",
    "data-name": "Warstwa 1",
    transform: "translate(40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M62.883,21.146a7.64,7.64,0,0,1-7.693-7.728,7.43,7.43,0,0,1,2.238-5.437,7.326,7.326,0,0,1,5.455-2.273H75.122v4.423H62.883a3.5,3.5,0,0,0-1.294.245,3.182,3.182,0,0,0-1.066.717,2.762,2.762,0,0,0-.7,1.066,3.13,3.13,0,0,0-.262,1.259,3.269,3.269,0,0,0,.962,2.36,3.164,3.164,0,0,0,2.36.979h6.574A7.763,7.763,0,0,1,77.2,24.45a7.448,7.448,0,0,1-2.29,5.455,7.378,7.378,0,0,1-5.455,2.255H56.222V27.737H69.474a3.409,3.409,0,0,0,2.36-.927,3.059,3.059,0,0,0,.7-1.049,3.339,3.339,0,0,0-.734-3.619,3.13,3.13,0,0,0-2.325-1Zm26.942,2.22h7.78l-3.881-7.78Zm9.983,4.371H87.57l-2.238,4.423h-4.86L93.689,5.726l13.217,26.435h-4.843l-2.29-4.423Zm25.718-17.606h-8.742v8.742h8.742a4.231,4.231,0,0,0,3.095-1.294,4.3,4.3,0,0,0,1.294-3.13,4.423,4.423,0,0,0-4.388-4.388Zm3.741,22.029h0l-5.105-8.742H116.7v8.742h-4.371V5.726h13.2a8.427,8.427,0,0,1,6.259,2.588,8.742,8.742,0,0,1,1.032,11.207,8.584,8.584,0,0,1-3.881,3.147l5.455,9.494ZM141.943,5.726h4.388V32.161h-4.388Zm25.229,0h0a12.92,12.92,0,0,1,5.14,1.032,13.183,13.183,0,0,1,4.231,2.85l-3.165,3.112a8.41,8.41,0,0,0-6.207-2.588,8.742,8.742,0,1,0,6.574,14.634V21.146H167.12V16.723h11.05v9.459a14.758,14.758,0,0,1-2.115,2.43,14.319,14.319,0,0,1-2.605,1.888,12.712,12.712,0,0,1-3.025,1.206,12.973,12.973,0,0,1-3.3.42,12.658,12.658,0,0,1-9.319-3.9,12.658,12.658,0,0,1-3.9-9.319,12.8,12.8,0,0,1,3.881-9.336,12.676,12.676,0,0,1,9.336-3.881Zm23.673,17.641h7.78l-3.9-7.78-3.9,7.78Zm10,4.371H188.607l-2.238,4.423h-4.913l13.27-26.435,13.218,26.435h-4.913Zm5.8-22.012h0v4.406H215.5V32.161h4.423V10.132h8.742V5.726Zm38.778,0h0a12.71,12.71,0,0,1,9.336,3.881,12.746,12.746,0,0,1,3.934,9.336,12.606,12.606,0,0,1-3.934,9.319,13.113,13.113,0,0,1-18.655,0,12.693,12.693,0,0,1-3.881-9.319,12.833,12.833,0,0,1,3.881-9.336,12.64,12.64,0,0,1,9.319-3.881Zm0,4.406h0a8.773,8.773,0,1,0,8.864,8.742,8.864,8.864,0,0,0-8.742-8.742Z",
    transform: "translate(41.301 4.257)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M61.55,26.762v1.451H57.214v2.867H61.55v1.434H57.214V35.4H55.78V26.657Zm19.232,0a4.109,4.109,0,0,1,3.06,1.276,4.178,4.178,0,0,1,1.294,3.06,4.336,4.336,0,0,1-7.413,3.06,4.161,4.161,0,0,1-1.259-3.06,4.213,4.213,0,0,1,1.259-3.06A4.109,4.109,0,0,1,80.781,26.762Zm0,1.451a2.867,2.867,0,1,0,2.046.839A2.832,2.832,0,0,0,80.781,28.214ZM107.2,31.833a3.5,3.5,0,0,1-1.066,2.553,3.6,3.6,0,0,1-6.259-2.553v-5.07h1.434v5.07a2.08,2.08,0,0,0,.629,1.521,2.133,2.133,0,0,0,3.06,0,2.028,2.028,0,0,0,.647-1.521v-5.07h1.451v5.07Zm14.843-5.088,5.77,5.245V26.745h1.451v8.742h0l-5.787-5.245v5.245h-1.434Zm22.064,0h2.885a4.179,4.179,0,0,1,1.748.35,4.3,4.3,0,0,1,2.308,2.308,4.2,4.2,0,0,1,0,3.357,4.668,4.668,0,0,1-.927,1.381,4.721,4.721,0,0,1-1.381.944,4.161,4.161,0,0,1-1.748.332h-2.885V26.675Zm2.885,7.238a2.972,2.972,0,0,0,1.119-.227,3.094,3.094,0,0,0,.927-.629,3.059,3.059,0,0,0,.612-.927,2.832,2.832,0,0,0,0-2.22,2.885,2.885,0,0,0-.629-.944,2.6,2.6,0,0,0-.927-.612,2.64,2.64,0,0,0-1.1-.227H145.54v5.787Zm20.718-1.469h2.553l-1.276-2.553Zm3.269,1.434h-3.986l-.734,1.434H164.65l4.336-8.742,4.336,8.742H171.7l-.717-1.434Zm14.249-7.238h7.308v1.451h-2.885v7.221H188.2V28.214h-2.9V26.762Zm22.082,0h1.434v8.742h-1.434Zm20.613,0a4.353,4.353,0,0,1,4.336,4.336,4.074,4.074,0,0,1-1.276,3.06,4.336,4.336,0,0,1-7.4-3.06,4.231,4.231,0,0,1,1.276-3.06,4.109,4.109,0,0,1,3.06-1.276Zm0,1.451a2.9,2.9,0,1,0,2.677,2.894,2.9,2.9,0,0,0-2.677-2.894Zm19.232-1.469,5.77,5.245V26.692h1.434v8.742h0l-5.77-5.245v5.245h-1.434Z",
    transform: "translate(41.743 19.936)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M71.97,28.35,69.942,10.709,60.623,1.39H44.958l-8.567,8.3-8.549-8.3H12.177L2.858,10.709.83,28.35l35.561,31.8Z",
    transform: "translate(0.621 1.04)",
    fill: "#c81a41",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M44.349,10.709,37.373,9.1,35.03,1.39Z",
    transform: "translate(26.215 1.04)",
    fillRule: "evenodd",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M44.349,10.709,37.565,7.684,35.03,1.39Z",
    transform: "translate(26.215 1.04)",
    fillRule: "evenodd",
    fill: "url(#sarfound-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    transform: "translate(3.479 2.43)",
    clipPath: "url(#clip-path-sarfound)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_81",
    "data-name": "Rectangle 81",
    width: 9.301,
    height: 9.336,
    fill: "url(#pattern2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M1.99,10.709,8.756,7.684,11.309,1.39Z",
    transform: "translate(1.489 1.04)",
    fillRule: "evenodd",
    fill: "url(#sarfound-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M21.17,9.695l6.224-.542L29.737,1.39Z",
    transform: "translate(15.843 1.04)",
    fillRule: "evenodd",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M36.391,9.695l-8.549-8.3H12.177L2.858,10.709.83,28.35l35.561,31.8Z",
    transform: "translate(0.621 1.04)",
    fillRule: "evenodd",
    fill: "url(#sarfound-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M21.17,9.695l6.224-1.836L29.737,1.39Z",
    transform: "translate(15.843 1.04)",
    fillRule: "evenodd",
    fill: "url(#sarfound-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M56.749,16.81,29.16,25.08,21.17,48.612Z",
    transform: "translate(15.843 12.58)",
    fillRule: "evenodd",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M56.749,16.81l-24.3,5.158L21.17,48.612Z",
    transform: "translate(15.843 12.58)",
    fillRule: "evenodd",
    fill: "url(#sarfound-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M51.225,6.46l5.927,5.979-6.469-.017V23.314L35.8,37.581,37.8,39.609l-3.112,4.2-9.494,7.518V27.458l-5.367-5.053L3.984,9.45l1.364-.612L3.11,8.751,10.471,1.39H21.835L35.489,15.6l11-9,.175-.14Z",
    transform: "translate(2.327 1.04)",
    fillRule: "evenodd",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M22.022,1.99v18.6L.08,1.99Z",
    transform: "translate(0.06 1.489)",
    fillRule: "evenodd",
    fill: "url(#sarfound-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M35.626,3.71l5.944,5.962H23.86L31.1,3.71Z",
    transform: "translate(17.856 2.776)",
    fillRule: "evenodd",
    fill: "url(#sarfound-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M22.082,0l7.85,7.8-7.85,14.284L0,0Z",
    fillRule: "evenodd",
    fill: "url(#sarfound-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M21.61,35.005V12.836L32.782,3.71H37.31v15.6Z",
    transform: "translate(16.172 2.776)",
    fillRule: "evenodd",
    fill: "url(#sarfound-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M12.63,22.082V0l22.2,22.082-6.5,15.7Z",
    transform: "translate(9.452)",
    fillRule: "evenodd",
    fill: "url(#sarfound-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M28.343,28.336,15.72,40.941V15.73l18.148,2.43-7.85,7.85Z",
    transform: "translate(11.764 11.771)",
    fillRule: "evenodd",
    fill: "url(#sarfound-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M28.33,28.33l-15.7-15.7h31.4Z",
    transform: "translate(9.452 9.452)",
    fillRule: "evenodd",
    fill: "url(#sarfound-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M12.63,0V20.176L13.1.472Z",
    transform: "translate(9.452)",
    fill: "#ffe098",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M12.64,12.62H44.023l-15.7.472Z",
    transform: "translate(9.459 9.444)",
    fill: "#ffe098",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M30.35,3.71l.42,4.965V3.71Z",
    transform: "translate(22.712 2.776)",
    fill: "#ffe098",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M15.72,15.73v.594l7.4,6.784Z",
    transform: "translate(11.764 11.771)",
    fill: "#ffe098",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M12.34,0h.507V20.176Z",
    transform: "translate(9.235)",
    fill: "#ef9239",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M12.64,12.785l21.8-.385,9.581.385Z",
    transform: "translate(9.459 9.28)",
    fill: "#ef9239",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M16.2,16.851,1.99,1.99,20.575,20.575Z",
    transform: "translate(1.489 1.489)",
    fill: "#ffe098",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M1.54,1.99h.787L13.761,13.424Z",
    transform: "translate(1.152 1.489)",
    fill: "#ef9239",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M31.027,9.036H30.59V4.56Z",
    transform: "translate(22.892 3.412)",
    fill: "#ef9239",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M27.624,15.037,21.96,8.76l-.35.3Z",
    transform: "translate(16.172 6.556)",
    fill: "#ffe098",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M25.32,24.6l-.35.367-7.85-7.85Z",
    transform: "translate(12.812 12.812)",
    fill: "#ef9239",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M22.475,33.586l1.416-1.416,2.623,15.3-4.056-12.5-.542,1.294L14.03,18.34l4.423.3Z",
    transform: "translate(10.499 13.725)",
    fillRule: "evenodd",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M.83,16.81,26.9,18.786l9.494,29.827Z",
    transform: "translate(0.621 12.58)",
    fillRule: "evenodd",
    fill: "url(#sarfound-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M24.829,9.695l-3.881.245-.42-.437L16.857,9.38,16.28,1.39Z",
    transform: "translate(12.183 1.04)",
    fillRule: "evenodd",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M24.829,9.695l-7.535-1L16.28,1.39Z",
    transform: "translate(12.183 1.04)",
    fillRule: "evenodd",
    fill: "url(#sarfound-gradient-14)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSarigatoFoundationLogo);
export default __webpack_public_path__ + "static/media/sarigato-foundation-logo.143f477f4225bf0c6578f9ee70538202.svg";
export { ForwardRef as ReactComponent };